import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


const doctorData = {
    Cardiologist: ["Dr. John Heart", "Dr. Smith Cardio"],
    Dermatologist: ["Dr. Anna Skin", "Dr. Rose Derm"],
    Orthopedic: ["Dr. Mike Bone", "Dr. Kevin Ortho"],
    Neurologist: ["Dr. Sarah Neuro", "Dr. David Brain"],
};
const Appointment = () => {
    const navigate = useNavigate();
    const [specialty, setSpecialty] = useState("");
    const [doctor, setDoctor] = useState("");
      const [showConfirm, setShowConfirm] = useState(false);

    return (
        <div className="content-wrapper">
            <div className="container-fluid table-padding">

                {/* PAGE HEADER */}
                <div className="page-header mb-4">
                    <div className="breadcrumb">
                        <h3 className="page-title">Book Appointment</h3>
                        <span className="customize-breadcrumb">
                            <span className="home-icon">🏠</span>
                            <span className="separator"> - </span>
                            <span>Appointment</span>
                            <span className="separator"> - </span>
                            <span>Book</span>
                        </span>
                    </div>
                </div>

                {/* FORM CARD */}
                <div className="card">
                    <div className="card-header bg-white border-bottom">
                        <h5 className="mb-0 fw-semibold">
                            📝 Book Appointment
                        </h5>

                    </div>
                    <div className="card-body">

                        {/* ================= PERSONAL INFO ================= */}
                        <h5 className="mb-3 border-bottom pb-2">
                            👤 Personal Info
                        </h5>

                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label">First Name</label>
                                <input type="text" className="form-control" placeholder="First Name" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Last Name</label>
                                <input type="text" className="form-control" placeholder="Last Name" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Date of Birth</label>
                                <input type="date" className="form-control" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Email</label>
                                <input type="email" className="form-control" placeholder="Email" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Contact Number</label>
                                <input type="text" className="form-control" placeholder="Phone" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Gender</label>
                                <select className="form-select">
                                    <option value="">Select</option>
                                    <option>Male</option>
                                    <option>Female</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div className="col-12">
                                <label className="form-label">Address</label>
                                <textarea className="form-control" rows={2} placeholder="Address" />
                            </div>
                        </div>

                        {/* ================= APPOINTMENT DETAILS ================= */}
                        <h5 className="mt-4 mb-3 border-bottom pb-2">
                            📅 Appointment Details
                        </h5>

                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label">Consulting Doctor</label>
                                <select className="form-select">
                                    <option>Select Consulting Doctor</option>
                                    <option>Dr. John</option>
                                    <option>Dr. Smith</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label">Doctor Specialty</label>
                                <select
                                    className="form-select"
                                    value={specialty}
                                    onChange={(e) => {
                                        setSpecialty(e.target.value);
                                        setDoctor(""); // reset doctor
                                    }}
                                >
                                    <option value="">Select Specialty</option>
                                    {Object.keys(doctorData).map((spec) => (
                                        <option key={spec} value={spec}>
                                            {spec}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Date of Appointment</label>
                                <input type="date" className="form-control" />
                            </div>

                            <div className="col-12">
                                <label className="form-label">Time of Appointment</label>

                                <div className="d-flex">
                                    {[
                                        "10:30 - 11:00",
                                        "11:00 - 11:30",
                                        "11:30 - 12:00",
                                        "12:00 - 12:30",
                                        "12:30 - 01:00",
                                        "03:30 - 04:00",
                                        "04:00 - 04:30",
                                        "04:30 - 05:00",
                                        "05:30 - 06:00",
                                    ].map((time) => (
                                        <div
                                            key={time}
                                            className="time-slot m-1"
                                            onClick={() => console.log("Selected:", time)}
                                        >
                                            {time}
                                        </div>
                                    ))}
                                </div>


                            </div>


                            <div className="col-12">
                                <label className="form-label">Upload Report</label>

                                <div className="upload-box">
                                    <input
                                        type="file"
                                        className="upload-input"
                                        id="uploadReport"
                                    />

                                    <label htmlFor="uploadReport" className="upload-label">
                                        <div className="upload-content">
                                            <i className="bi bi-upload upload-icon"></i>
                                            <p className="mb-1 fw-semibold">
                                                Drag & drop your report here
                                            </p>
                                            <p className="text-muted small mb-2">
                                                or click to browse
                                            </p>
                                            <span className="upload-hint">
                                                (PDF, JPG, PNG, DOCX • max 10MB)
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>


                            <div className="col-12">
                                <label className="form-label">Problem</label>
                                <textarea className="form-control" rows={2} />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Symptoms</label>
                                <textarea className="form-control" rows={2} />
                            </div>

                            <div className="col-12">
                                <label className="form-label">Note</label>
                                <textarea className="form-control" rows={2} placeholder="If you're taking any medicine, please type it here." />
                            </div>
                        </div>

                        {/* ================= ACTION BUTTONS ================= */}
                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                className="btn btn-warning"
                                onClick={() => navigate(-1)}
                            >
                                Cancel
                            </button>

                            <button className="btn btn-primary" onClick={()=>setShowConfirm(true)}>
                                Schedule Appointment
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <Dialog
                open={showConfirm}
                maxWidth="sm"
                fullWidth
                className="auth-modal glass-modal"
                onClose={() => setShowConfirm(false)}
                BackdropProps={{
                    style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
                }}
            >
                <DialogTitle className="pt-30 pb-10 text-center">
                    <h3>Your appointment has been scheduled!</h3>
                </DialogTitle>

                <DialogContent className="px-40 pb-30 text-center">
                    {/* Tick Animation */}
                    <div className="tick-animation">
                        <svg
                            width="60"
                            height="60"
                            viewBox="0 0 100 100"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="50" cy="50" r="48" stroke="green" strokeWidth="4" fill="none" />
                            <path
                                id="tickPath"
                                d="M20 50L40 70L80 30"
                                stroke="green"
                                strokeWidth="6"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="tick-path"
                            />
                        </svg>
                    </div>

                    <p className="mb-3">
                        Please note: To provide complete information, we recommend filling out the health questionnaire form for this family member.
                    </p>
                    <p className="text-muted fs-14">
                        Would you like to fill the questionnaire now?
                    </p>
                </DialogContent>

                <DialogActions className="pb-30 px-40 d-flex justify-content-center gap-3">
                  
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowConfirm(false);
                        
                        }}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Appointment;
